import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Row, Col, Card, CardHeader, CardTitle, CardBody, ListGroup, ListGroupItem, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';

import { getLoggedUser } from '../../UserActions';
import { isFetching } from '../../../App/AppActions';


class CustomerDashboard extends Component {
    render() {
        const { user, conversations } = this.props;

        if(user) {
            return (
                <div>
                    Customer dashboard: profile / orders / addresses
                </div>
            );
        }
        return null;
    }
}

function mapStateToProps(store, props) {
    const user = getLoggedUser(store);
    return {
        user,
        isFetching: {},
    };
}

CustomerDashboard.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    user: PropTypes.object.isRequired,
    isFetching: PropTypes.object,
};

export default connect(mapStateToProps)(injectIntl(CustomerDashboard));
